module.exports = __webpack_public_path__ + "img/1557614096827883522.d368ebdb.png";